import { FormEvent } from 'react'
import { Link } from 'react-router-dom'

import { cnpjCpfMask, parseDate } from '../../utils/masks'
import { BiDollarCircle } from 'react-icons/bi'
import { RiExchangeDollarLine } from 'react-icons/ri'
import { TableApproveLinks } from './styles'
import dayjs from '../../libs/dayjs'
import { HiOutlineReceiptPercent } from 'react-icons/hi2'
interface Props {
    approveLinks: any[]
}

const ToApprove = ({ approveLinks }: Props) => {
    function handleDecline(e: FormEvent, id: string) {
        e.preventDefault()
    }

    function renderRowsMyLinks() {
        return approveLinks.map((link: any) => {
            return (
                <tr key={link.id}>
                    <td>
                        {dayjs(link.createdAt).format('DD/MM/YYYY - HH:mm:ss')}
                    </td>
                    <td>{link.nomeTitular}</td>
                    <td>{cnpjCpfMask(link.numeroDocumentoTitular)}</td>
                    <td>{parseDate(link.dataLiquidacao, true)}</td>
                    <td>
                        {Number(link.valor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </td>
                    {/* <td>{link.quantParcelas} parcelas</td> */}
                    <td className="">
                        {/* <form onSubmit={(e) => handleDecline(e, link.id)}> */}
                            <Link to={`/${link.id}`}>
                                <button className="px-2 py-1 border-transparent border-solid border border-blue-600 text-blue-500 bg-blue-100 rounded-lg shadow-sm">
                                    Ver link
                                </button>
                            </Link>
                        {/* </form> */}
                    </td>
                    <td className="tipo">
                        {link.tipoLink === 0 && (
                            <BiDollarCircle color="#333" size={22} />
                        )}
                        {link.tipoLink === 1 && (
                            <RiExchangeDollarLine color="#333" size={22} />
                        )}
                        {link.tipoLink === 2 && (
                            <HiOutlineReceiptPercent color="#333" size={22} />
                        )}
                    </td>
                </tr>
            )
        })
    }
    return (
        <TableApproveLinks>
            <thead>
                <tr>
                    <th>Data de criação</th>
                    <th>Enviado por</th>
                    <th>
                        CNPJ/CPF <br />
                        (Quem te enviou)
                    </th>
                    <th>Data liquidação</th>
                    <th>Valor</th>
                    {/* <th>N. Parcelas</th> */}
                    <th>Ações</th>
                    <th>Tipo</th>
                </tr>
            </thead>

            <tbody>{renderRowsMyLinks()}</tbody>
        </TableApproveLinks>
    )
}

export default ToApprove
